/*
 * Blog pagination (sections/blog.liquid)
 * All market-visible posts are rendered with data-page. The current page comes from ?p=N and is
 * applied as a style before the posts are parsed, so no other page is shown first.
 * Old Shopify ?page=N links redirect to ?p=N.
 */
(function () {
  const params = new URLSearchParams(window.location.search);
  const path = window.location.pathname;
  const legacyPage = parseInt(params.get('page'), 10);

  if (legacyPage > 1) {
    window.location.replace(`${path}?p=${legacyPage}`);
    return;
  }

  const style = document.createElement('style');
  document.head.appendChild(style);
  let current = Math.max(parseInt(params.get('p'), 10) || 1, 1);

  const showPage = (page) => {
    style.textContent = `.blog-listing .blog-article:not([data-page="${page}"]) { display: none; }`;
  };
  showPage(current);

  document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('[data-page-link]');
    const pages = Math.max(links.length, 1);

    if (current > pages) {
      current = pages;
      showPage(current);
    }

    links.forEach((link) => {
      if (parseInt(link.dataset.pageLink, 10) !== current) return;
      const active = document.createElement('span');
      active.className = 'pagination-custom__page pagination-custom__page--active';
      active.textContent = link.textContent;
      link.replaceWith(active);
    });

    const prev = document.querySelector('[data-page-prev]');
    const next = document.querySelector('[data-page-next]');
    if (!prev || !next) return;

    prev.classList.toggle('is-hidden', current === 1);
    prev.href = `${path}?p=${current - 1}`;
    next.classList.toggle('is-hidden', current === pages);
    next.href = `${path}?p=${current + 1}`;
  });
})();
